module.exports = __webpack_public_path__ + "static/media/blk-design-system-pro-react.67aa3793.jpg";